import React, { useEffect, useMemo, useRef, useState } from "react";
import { throttle } from "lodash";

const useColumn = (): number => {
  const [winWidth, setWinWidth] = useState<number>(document.body.clientWidth);
  const throttled = useRef(throttle((w) => setWinWidth(w), 1000));
  useEffect(() => {
    const resizeCallback = (e: UIEvent) => {
      throttled.current(document.body.clientWidth);
    };
    window.addEventListener("resize", resizeCallback);
    return () => {
      window.removeEventListener("resize", resizeCallback);
    };
  }, []);
  const column = useMemo(() => {
    if (winWidth <= 600) {
      return 2;
    } else if (winWidth > 600 && winWidth <= 1200) {
      return 3;
    } else if (winWidth > 1200 && winWidth <= 1800) {
      return 4;
    } else if (winWidth > 1800 && winWidth <= 2800) {
      return 5;
    } else if (winWidth > 2800 && winWidth <= 3500) {
      return 6;
    } else if (winWidth > 3500 && winWidth <= 4000) {
      return 7;
    } else {
      return 8;
    }
  }, [winWidth]);
  return column;
};

export default useColumn;
